import { render, staticRenderFns } from "./MainMenuScreen.vue?vue&type=template&id=644c83d5&scoped=true&"
import script from "./MainMenuScreen.vue?vue&type=script&lang=js&"
export * from "./MainMenuScreen.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuScreen.vue?vue&type=style&index=0&id=644c83d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c83d5",
  null
  
)

export default component.exports